<div
	class="ikea-container bg-grey-100 padding-xl position-relative"
	*ngIf="active"
>
	<button
		*ngIf="isDismissable"
		type="button"
		class="btn-circle dismiss-button"
		(click)="dismiss($event)"
	>
		<app-ikea-icon iconName="close-btn"></app-ikea-icon>
	</button>

	<div class="alert-body">
		<ng-content></ng-content>
	</div>
</div>
